export class MisconfiguredDeviceError {
  public brandIdentifier: string;

  constructor(brandIdentifier: string) {
    this.brandIdentifier = brandIdentifier.toLowerCase();
  }
}
